import React, { Component } from 'react';
import LoadingButtonBase from './LoadingButtonBase';

type LoadingButtonProps = {
    className?: string;
    label: string;
    onClick(): boolean | Promise<boolean>;
};

type LoadingButtonState = {
    loading: boolean;
};

export default class LoadingButton extends Component<LoadingButtonProps, LoadingButtonState> {
    state: LoadingButtonState = {
        loading: false,
    };

    static displayName = LoadingButton.name;

    executeOnClick = async () => {
        // If an onClick has been provided, execute the function and indicate the button is loading in the meantime.
        if (this.props.onClick) {
            this.setState({ loading: true });
            let result = undefined;
            try {
                // await regardless of whether the onClick is async, just in case.
                result = await this.props.onClick();
            }
            finally {
                if (!result)
                    this.setState({ loading: false });
            }
        }
    };

    render() {
        return (
            <LoadingButtonBase className={this.props.className} onClick={this.executeOnClick} loading={this.state.loading} label={this.props.label} />
        );
    }
}
